import { getCard } from "../content/lookups.js";
import { useGame } from "../app/GameProvider.js";
import { CardView } from "./CardView.js";
import { selectionBannerText } from "./selectionBannerText.js";

type SelectionBannerProps = {
  onSubmit?: () => void;
};

export function SelectionBanner({ onSubmit }: SelectionBannerProps) {
  const { state, dispatch } = useGame();
  const run = state.run;
  const pending = run?.pendingChoice;
  if (!run || !pending) return null;

  const selected =
    pending.kind === "knowledgeShare" || pending.kind === "caseExclude" || pending.kind === "cellar" || pending.kind === "sendoff" || pending.kind === "handDisruption"
      || pending.kind === "training" || pending.kind === "workerCycle" || pending.kind === "stables" || pending.kind === "inn"
      || pending.kind === "psychologicalCounseling" || pending.kind === "specialTaskTeam"
      ? pending.selected
      : pending.kind === "meeting" && pending.targetInstanceId
        ? [pending.targetInstanceId]
        : [];

  const targets =
    pending.kind === "knowledgeShare"
        ? run.discard
        : [];

  const reveal = pending.kind === "fieldJudgment"
    ? [pending.revealed]
    : pending.kind === "focus" && pending.pendingCard
      ? [pending.pendingCard]
      : pending.kind === "quality" && pending.step < pending.revealed.length
        ? [pending.revealed[pending.step]]
        : [];

  const selectionStatus =
    pending.kind === "quality"
      ? `処理 ${pending.step} / ${pending.revealed.length} 枚`
      : pending.kind === "fieldJudgment"
        ? null
        : pending.kind === "focus"
          ? "置き場所を選んでください"
          : pending.kind === "handDisruption"
            ? `選択 ${selected.length} / ${pending.count} 枚`
            : `選択 ${selected.length} 枚`;

  return (
    <div className="pending-banner" role="dialog" aria-modal="true" aria-label="カード選択">
      <p>{selectionBannerText(pending)}</p>
      {selectionStatus ? <p className="pending-count">{selectionStatus}</p> : null}
      {reveal.length > 0 && (
        <div className="selection-reveal">
          {reveal.map((card) => {
            const definition = getCard(card.cardId);
            return definition ? <CardView key={card.instanceId} card={card} definition={definition} disabled /> : null;
          })}
        </div>
      )}
      {reveal.length > 0 && pending.kind !== "fieldJudgment" && (
        <div className="row" style={{ marginTop: 8 }}>
          {pending.kind === "focus" && <>
            <button type="button" className="btn" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "aside" })}>脇に置く</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "hand" })}>手札へ</button>
          </>}
          {pending.kind === "quality" && <>
            <button type="button" className="btn btn-danger" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "destroy" })}>廃棄</button>
            <button type="button" className="btn" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "discard" })}>捨て札</button>
            <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "return" })}>戻す</button>
          </>}
        </div>
      )}
      {pending.kind === "fieldJudgment" && (
        <div className="row" style={{ marginTop: 8 }}>
          <button type="button" className="btn" onClick={() => dispatch({ type: "OPEN_OVERLAY", overlay: "skipFieldJudgmentConfirm" })}>戻す</button>
          <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "TOGGLE_SELECTION", value: "use" })}>使用する</button>
        </div>
      )}
      {targets.length > 0 && (
        <div className="hand">
          {targets.map((card) => {
            const def = getCard(card.cardId);
            if (!def) return null;
            const picked = selected.includes(card.instanceId);
            return (
              <CardView
                key={card.instanceId}
                card={card}
                definition={def}
                playable
                selectable
                picked={picked}
                onClick={() => dispatch({ type: "TOGGLE_SELECTION", instanceId: card.instanceId })}
              />
            );
          })}
        </div>
      )}
      {pending.kind !== "fieldJudgment" && (
        <button type="button" className="btn btn-primary" onClick={onSubmit ?? (() => dispatch({ type: "SUBMIT_SELECTION" }))}>
          選択を確定
        </button>
      )}
    </div>
  );
}
